module.exports = __webpack_public_path__ + "static/media/BB_gauge_bg.2f600227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_gauge_bg.png
// module id = 1207
// module chunks = 0